export const initMeganavToggle = (): void => {
  const navItems = document.querySelectorAll('[data-nav-item]');
  if (navItems.length <= 0) return;

  const navToggles = document.querySelectorAll('[data-nav-toggle]');
  const classToToggle = 'menu-open';
  const MOBILE_BREAKPOINT = 768;

  const closeAllMeganavs = () => {
    navItems.forEach(t => t.classList.remove(classToToggle));
    document.querySelector('body').dataset.modalTriggered = '';
  };

  const openMeganav = (e) => {
    let parent = e.target;
    if (parent.dataset.navToggle === '') {
      parent = e.target.parentElement;
    }

    if (parent) {
      if (!parent.classList.contains(classToToggle)) {
        // Closing all mega navs
        closeAllMeganavs();

        // overlay
        document.querySelector('body').dataset.modalTriggered = 'modal-menu';
      } else {
        document.querySelector('body').dataset.modalTriggered = '';
      }

      // Toggle this mega nav
      parent.classList.toggle(classToToggle);
    }
  };

  navItems.forEach(navItem => {
    navItem.addEventListener('mouseenter', (e) => window.innerWidth >= MOBILE_BREAKPOINT ? openMeganav(e) : false);
    navItem.addEventListener('mouseleave', () => window.innerWidth >= MOBILE_BREAKPOINT ? closeAllMeganavs() : false);
  });

  navToggles.forEach(navToggle => {
    navToggle.addEventListener('click', (e) => window.innerWidth < MOBILE_BREAKPOINT ? openMeganav(e) : false);
  });

  document.querySelector('[data-modal-underlay]').addEventListener('click', () => {
    // Closing all mega navs
    closeAllMeganavs();
  });

  document.querySelectorAll('[data-nav-btn-back]').forEach(btn =>
    btn.addEventListener('click', () => {
      // Closing all mega navs
      closeAllMeganavs();
    })
  );

}